<template>
  <div class="main">
    <!-- start: page -->
    <section class="panel panel-default">
      <header class="panel-heading">
        <div class="panel-actions">
          <a href="javascript:" @click="() => {isEditPrivacy = !isEditPrivacy;}" v-if="this.isAdmin('stay')">編輯</a>
          <a href="#privacy" data-toggle="collapse" class="panel-action panel-action-toggle"
             @click="isViewPrivacy = true" v-if="!isSavable"></a>
        </div>
        <h1 v-show="!isEditPrivacy" class="panel-title">{{ model.PolicyAnnounce.title }} 第{{ model.PolicyAnnounce.version }}版</h1>
        <div v-show="isEditPrivacy" class="form-group">
          <label for="title">標題</label>
          <div>
            <input id="title" name="title" v-model="model.PolicyAnnounce.title" type="text" class="form-control"/>
          </div>
          <label for="title">版本</label>
          <div>
            <input id="version" name="version" v-model="model.PolicyAnnounce.version" type="text" class="form-control"/>
          </div>
        </div>
      </header>
      <div id="privacy" :class="!isSavable ? `panel-collapse collapse in`:``">
        <div class="panel-body" v-html="model.PolicyAnnounce.content" v-if="!isEditPrivacy"></div>
        <ckeditor v-model="model.PolicyAnnounce.content" :config="editorConfig" v-if="isEditPrivacy"></ckeditor>
      </div>
      <footer class="panel-footer" v-show="isViewPrivacy" v-if="!isSavable">
        <label class="s_agr">
          <input type="checkbox" v-validate="'required'" name="privacyCheckBox" v-model="privacyCheckBox">
          我同意以上{{ model.PolicyAnnounce.title }}
        </label>
        <span class="text-danger" v-show="errors.has('privacyCheckBox')">{{ errors.first('privacyCheckBox') }}</span>
      </footer>
    </section>
    <div class="col-md-12">
      <div class="s_tenc" v-if="!isSavable">
        <a @click="nextClick" class="btn-upload btn s_btn_b">下一步</a>
      </div>
      <div class="s_tenc" v-if="isSavable">
        <a @click="saveClick" class="btn-upload btn s_btn_b">儲存</a>
      </div>
    </div>
  </div>
</template>

<script>
import CKEditor from "@/ckeditor4";

export default {
  components: {
    ckeditor: CKEditor.component
  },
  props: ['type'],
  data() {
    return {
      isSavable: false,
      privacyCheckBox: false,
      stayOfficeCheckBox: false,
      lifeConventionCheckBox: false,
      isViewPrivacy: true,
      isEditPrivacy: false,
      model: {
        PolicyAnnounce: {}
      },
      editorConfig: {
        extraPlugins: ["colorbutton"],
        height: 500,
        toolbar: [
          ["Source"],
          ["Cut", "Copy", "Paste", "PasteText", "PasteFromWord"],
          ["Undo", "Redo"],
          ["RemoveFormat"],
          ["NumberedList", "BulletedList"],
          ["Outdent", "Indent"],
          ["Blockquote"],
          ["Link", "Unlink", "Anchor"],
          ["Table", "HorizontalRule"],
          ["SpecialChar"],
          "/",
          ["Styles", "Format"],
          ["Bold", "Italic", "Strike"],
          ["TextColor", "BGColor"],
          ["Maximize"],
          ["About"]
        ]
      },
    }
  },
  mounted() {
    if(this.$route.name === "relief.treaty") {
      this.type = 'relief';
      this.isSavable = true;
    } else if(this.$route.name === "weak.treaty") {
      this.type = 'weak';
      this.isSavable = true;
    }
    this.$axios.get(`/api/common/treaty?type=${this.type}`).then(resp => {
      this.model = resp.data;
      this.model.PolicyAnnounce.content = this.htmlDecode(this.model.PolicyAnnounce.content);
    });
  },
  methods: {
    nextClick() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$parent.isShowTreaty = false;
        } else {
          bootbox.alert("請確認條約是否有打勾")
        }
      });
    },
    saveClick() {
      let errorMsgs = [];
      if (!this.model.PolicyAnnounce.content) {
        errorMsgs.push(`請填寫${this.model.PolicyAnnounce.title}`);
      }
      if (errorMsgs.length > 0) {
        bootbox.alert(errorMsgs.join("<br/>"));
        return false;
      }
      const formData = new FormData();
      formData.append("treaty", JSON.stringify({
        PolicyAnnounce: {
          title: this.model.PolicyAnnounce.title,
          version: this.model.PolicyAnnounce.version,
          content: this.htmlEncode(this.model.PolicyAnnounce.content)
        }
      }));
      const _this = this;
      if(this.$route.name === "relief.treaty") {
        this.type = 'relief';
      } else if(this.$route.name === "weak.treaty") {
        this.type = 'weak';
      }
      formData.append("type", this.type);
      this.$axios.post(`/api/common/saveTreaty`, formData).then(resp => {
        bootbox.alert(resp.data.msg, function () {
          if (resp.data.status === "success") {
            _this.$router.go(-1);
          }
        });
      });
    }
  }
}
</script>
